// RU-STRATDRILL SD-1: one shared opener for the strategy drill-down drawer. Any screen calls
// openStrategyDrawer({id, name}); StrategyDrawerHost (mounted once in AppShell) renders the drawer.
export const STRATEGY_DRAWER_EVENT = "algoforge:strategy-drawer";

export function openStrategyDrawer(strategy) {
  if (!strategy || !strategy.id) return;
  window.dispatchEvent(new CustomEvent(STRATEGY_DRAWER_EVENT, { detail: strategy }));
}

export function onStrategyDrawer(fn) {
  const h = (e) => fn(e.detail);
  window.addEventListener(STRATEGY_DRAWER_EVENT, h);
  return () => window.removeEventListener(STRATEGY_DRAWER_EVENT, h);
}
